import moment from "moment";
import { httpApi } from "api/http.api";
import { IEditDeleteId, IUserData, UserRequest, UserResponse } from "domain/User";
import { AxiosResponse } from "axios";
import { PermissionsResponse } from "domain/Permissions";

export const getAccountUserList = (): Promise<IUserData[]> =>
  httpApi
    .get<{ data: IUserData[] }>("Users/V2")
    .then(({ data }) => data.data)
    .then((data) => data);

export const addAccountUser = (userPayload: UserRequest): Promise<UserResponse> =>
  httpApi
    .post<UserResponse>("Users/AddAccountUser/V2", {
      ...userPayload,
    })
    .then(({ data }) => data);

export const updateAccountUser = (
  id: IEditDeleteId,
  userPayload: UserRequest
): Promise<UserResponse> =>
  httpApi
    .put<UserRequest>(`Users/${id}/UpdateAccountUser/V2`, {
      ...userPayload,
    })
    .then(({ data }) => data);

export const updatePassword = (
  id: IEditDeleteId,
  userPayload: UserRequest
): Promise<UserResponse> =>
  httpApi
    .put<UserRequest>(`Users/${id}/ChangePassword`, {
      ...userPayload,
    })
    .then(({ data }) => data);

export const getAccountUserById = (id: IEditDeleteId): Promise<IUserData> =>
  httpApi
    .get<any>(`Users/V2/${id}`)
    .then(({ data }) => data["data"][0])
    .then((data) => data);

export const activateAccountUser = (id: IEditDeleteId): Promise<UserResponse> =>
  httpApi
    .put<UserRequest>(`Users/${id}/ActivateUser`, {})
    .then(({ data }) => data);

export const deActivateAccountUser = async (id: IEditDeleteId): Promise<UserResponse> => {
  let time = moment().toISOString();
  let hmac_token: AxiosResponse<PermissionsResponse> = await httpApi.delete<UserResponse>(
    `Users/${id}/DeactivateUser`,
    {
      data: { hmac_time: time },
    }
  );

  return httpApi.delete<UserResponse>(`Users/${id}/DeactivateUser`, {
    data: { hmac_time: time, hmac: hmac_token?.data?.hmac },
  });
};

export const getRoleProfile = (): Promise<IUserData[]> =>
  httpApi.get<IUserData[]>("Roles").then(({ data }) => data);

export const deleteAccountUser = async (id: IEditDeleteId): Promise<UserResponse> => {
  let time = moment().toISOString();
  let hmac_token: AxiosResponse<PermissionsResponse> = await httpApi.delete<UserResponse>(
    `Users/${id}/DeleteUser`,
    {
      data: { hmac_time: time },
    }
  );

  return httpApi.delete<UserResponse>(`Users/${id}/DeleteUser`, {
    data: { hmac_time: time, hmac: hmac_token?.data?.hmac },
  });
};
